<template>
  <div :class="cn('inline-flex items-center gap-[4px] bg-[#F5F5F5] rounded-[12px] p-[4px] max-w-full overflow-x-auto no-scrollbar')">
    <slot />
  </div>
</template>

<script>
import { cn } from '../utils'

export default {
  name: 'Tabs',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    defaultValue: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      internalValue: this.defaultValue,
    }
  },
  computed: {
    activeValue() {
      return this.value !== null ? this.value : this.internalValue
    },
  },
  provide() {
    return {
      tabsState: this,
    }
  },
  methods: {
    cn,
    setActive(val) {
      this.internalValue = val
      this.$emit('input', val)
    },
  },
}
</script>

<style scoped>
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
